import { FaShieldAlt, FaFileAlt, FaLock } from 'react-icons/fa';
import { Link } from 'react-scroll';

export default function SecureOrgSection() {
    return (
        <section className="bg-[#0d0d0d] py-20 px-6 md:px-12">
            <div className="max-w-6xl mx-auto bg-black border border-gray-700 rounded-lg p-10 md:flex md:items-center md:justify-between shadow-lg" data-aos="fade-up" data-aos-duration="800">
                {/* Left: CTA */}
                <div className="md:w-1/2 mb-10 md:mb-0">
                    <h2 className="text-white text-2xl md:text-3xl font-bold mb-4">
                        Ready to Secure Your Organization?
                    </h2>
                    <p className="text-gray-400 mb-6 text-sm md:text-base max-w-md">
                        Our team of expert security professionals is ready to help you identify and address
                        vulnerabilities before they can be exploited.
                    </p>
                    <div className="flex gap-4 flex-wrap">

                        <Link
                            to="contact"
                            smooth={true}
                            offset={-20}
                            duration={500}
                            className="bg-red-600 hover:bg-red-700 text-white font-semibold px-5 py-2 rounded inline-block cursor-pointer"
                        >
                            Schedule a Consultation →
                        </Link>
                    </div>
                </div>

                {/* Right: Feature List */}
                <div className="md:w-1/2 space-y-6">
                    {[
                        {
                            icon: <FaShieldAlt className="text-white" />,
                            title: 'Experienced Security Team',
                            desc: 'Our red team consists of certified security professionals with years of experience.',
                        },
                        {
                            icon: <FaFileAlt className="text-white" />,
                            title: 'Comprehensive Reports',
                            desc: 'Detailed findings with clear remediation steps and executive summaries.',
                        },
                        {
                            icon: <FaLock className="text-white" />,
                            title: 'Confidentiality Assured',
                            desc: 'All engagements are conducted with the highest level of confidentiality.',
                        },
                    ].map((item, index) => (
                        <div key={index} className="flex items-start gap-4">
                            <div className="bg-red-700 w-10 h-10 rounded-full flex items-center justify-center shrink-0 mt-1">
                                {item.icon}
                            </div>
                            <div>
                                <h4 className="text-white font-semibold">{item.title}</h4>
                                <p className="text-gray-400 text-sm mt-1">{item.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
